import { Modal, Tabs } from 'antd';
import { ReactComponent as CloseIcon } from "../../../../assets/svgs/icons/close-icon.svg";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SupportManagerContainer } from './supportManager.styles';
import SupportDetails from './support/SupportDetails';
import SupportTicketsDetails from './support/tickets/SupportTicketsDetails';
import { Ticket } from './SupportManagerType';


const SupportManager = () => {
    const [show, setShow] = useState<boolean>(true);
    const navigate = useNavigate();
    const [viewingTicket, setViewingTicket] = useState<Ticket | null>(null);

    const handleCancel = () => {
        setShow(false);
        navigate('/')
    };

    const handleTabChange = (key: string) => {
        if (key === "2") {
            setViewingTicket(null);
        }
    };

    const tabItems = [
        {
            label: <span>Support</span>,
            key: "1",
            children: (
                <>
                    <SupportDetails onCancel={handleCancel} />
                </>
            ),
        },
        {
            label: <span>Tickets</span>,
            key: "2",
            children: (
                <>
                    <SupportTicketsDetails viewingTicket={viewingTicket} setViewingTicket={setViewingTicket} />
                </>
            ),
        },
    ];


    return (
        <Modal
            centered
            open={show}
            className="batch_modal create_batch_modal quota_modal"
            onCancel={handleCancel}
            closeIcon={
                <CloseIcon key="CloseIcon" color="#ffffff" onClick={handleCancel} />
            }
            footer={null}
            style={{
                backgroundColor: "#36BDBE",
                width: "100%", // Adjust the width as per your need
                maxWidth: "100%", // Set maximum width if needed
            }}
        >
            <SupportManagerContainer>
                <div className="table-container">
                    <div className="custom-tab-container">
                        <Tabs
                            defaultActiveKey="1"
                            items={tabItems}
                            onChange={handleTabChange}
                            key="1"
                            className="custom-tabs custom_payment_tabs"
                        ></Tabs>
                    </div>
                </div>
            </SupportManagerContainer>
        </Modal>
    );
}

export default SupportManager;
